import * as actionTypes from "../actions/actionTypes";

const initState = {
  loadingGetActPosts: false,
  activityPosts: null,
  activityError: null,
  // ModeratorComments:
  loadingModeratorComments: false,
  comments: [],
  //comments: {},
  moderatorCommentError: null,
  // Post Comments:
  loadingPostComments: false,
  postComments: [],
  postCommentsError: false,
  //Payment History:
  loadingPaymentHistory: false,
  paymentHistory: null,
  pymentHistoryError: null,
  //Invoices:
  loadingInvoices: false,
  invoices: null,
  invoicesError: null,
};

const initGetActivityPosts = (state, action) => {
  return {
    ...state,
    loadingGetActPosts: action.loadingGetActPosts,
  };
};

const successGetActivityPosts = (state, action) => {
  return {
    ...state,
    loadingGetActPosts: action.loadingGetActPosts,
    activityPosts: action.activityPosts,
  };
};

const failGetActivityPosts = (state, action) => {
  return {
    ...state,
    loadingGetActPosts: action.loadingGetActPosts,
    activityError: action.activityError,
  };
};

// Moderator Commetns:
const initGetModeratorComments = (state, action) => {
  return {
    ...state,
    loadingModeratorComments: action.loadingModeratorComments,
  };
};

const successGetModeratorComments = (state, action) => {
  // const updateComments = { ...state.comments };
  // const updatedkey = action.key;
  // const updatedvalue = action.value;
  // updateComments[`${updatedkey}`] = updatedvalue

  return {
    ...state,
    loadingModeratorComments: action.loadingModeratorComments,
    comments: action.comments,
  };
};

const failGetModeratorComments = (state, action) => {
  return {
    ...state,
    loadingModeratorComments: action.loadingModeratorComments,
    moderatorCommentError: action.moderatorCommentError,
  };
};
// Moderator Commetns:
const initGetPostComments = (state, action) => {
  return {
    ...state,
    loadingPostComments: action.loadingPostComments,
  };
};

const successGetPostComments = (state, action) => {
  return {
    ...state,
    loadingPostComments: action.loadingPostComments,
    postComments: action.postComments,
  };
};

const failGetPostComments = (state, action) => {
  return {
    ...state,
    loadingPostComments: action.loadingPostComments,
    postCommentsError: action.postCommentsError,
  };
};

// Payment History:

const initGetPaymentHisotry = (state, action) => {
  return {
    ...state,
    loadingPaymentHistory: action.loadingPaymentHistory,
  };
};

const successGetPaymentHisotry = (state, action) => {
  return {
    ...state,
    loadingPaymentHistory: action.loadingPaymentHistory,
    paymentHistory: action.paymentHistory,
  };
};

const failGetPaymentHisotry = (state, action) => {
  return {
    ...state,
    pymentHistoryError: action.pymentHistoryError,
  };
};

const initGetInvoices = (state, action) => {
  return {
    ...state,
    loadingInvoices: action.loadingInvoices,
  };
};

const successGetInvoices = (state, action) => {
  return {
    ...state,
    loadingInvoices: action.loadingInvoices,
    invoices: action.invoices,
  };
};

const failGetInvoices = (state, action) => {
  return {
    ...state,
    loadingInvoices: action.loadingInvoices,
    invoicesError: action.invoicesError,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_GET_ACTIVTY_POSTS:
      return initGetActivityPosts(state, action);
    case actionTypes.SUCCESS_GET_ACTIVTY_POSTS:
      return successGetActivityPosts(state, action);
    case actionTypes.FAIL_GET_ACTIVTY_POSTS:
      return failGetActivityPosts(state, action);
    // Moderator Comment:
    case actionTypes.INIT_GET_MODERATOR_COMMENTS:
      return initGetModeratorComments(state, action);
    case actionTypes.SUCCESS_GET_MODERATOR_COMMENTS:
      return successGetModeratorComments(state, action);
    case actionTypes.FAIL_GET_MODERATOR_COMMENTS:
      return failGetModeratorComments(state, action);
    // Post Comment:
    case actionTypes.GET_POST_COMMENTS:
      return initGetPostComments(state, action);
    case actionTypes.SUCCESS_GET_POST_COMMENTS:
      return successGetPostComments(state, action);
    case actionTypes.FAIL_GET_POST_COMMENTS:
      return failGetPostComments(state, action);
    //Payment History:
    case actionTypes.INIT_GET_PAYMENT_HISTORY:
      return initGetPaymentHisotry(state, action);
    case actionTypes.SUCCESS_GET_PAYMENT_HISTORY:
      return successGetPaymentHisotry(state, action);
    case actionTypes.FAIL_GET_PAYMENT_HISTORY:
      return failGetPaymentHisotry(state, action);
    //Invoices:
    case actionTypes.INIT_GET_INVOICES:
      return initGetInvoices(state, action);
    case actionTypes.SUCCESS_GET_INVOICES:
      return successGetInvoices(state, action);
    case actionTypes.FAIL_GET_INVOICES:
      return failGetInvoices(state, action);
    default:
      return state;
  }
};

export default Reducer;
